import * as React from 'react';
import { get, noop } from 'lodash';
import { compose, withHandlers, withProps, defaultProps } from 'recompose';
import { reduxForm } from 'redux-form';
import { Row, Col, Grid } from 'react-flexbox-grid';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { AutoCompleteField, AutoComplete, DateField, Date } from '@components/form';
import { paymentMethodEnum } from '@modules/delicts/_delictsEnums';
import { payBNPTicket } from '@modules/tickets/_ticketsActions';
import { getActualDate } from '@utils/utils';
import { withNotifications } from '@components/hoc/withNotifications';
import { required } from '@utils/validators';

const enhance = compose<any, any>(
  defaultProps({ reloadDelict: noop }),
  withNotifications({ payBNPTicket }),
  withHandlers({
    onSubmit: ({ reloadDelict, ticketId, closeItem, payBNPTicketNotify }) => async formData => {
      const result = await payBNPTicketNotify({ id: ticketId, ...formData });
      if (result) {
        await reloadDelict();
        closeItem();
      }
    }
  }),
  withProps({ initialValues: { payDate: getActualDate() } }),
  reduxForm({ form: 'module-events-delicts-agreement' })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <h4>Zaplatit BNP</h4>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <AutoCompleteField
                  component={AutoComplete}
                  name={'method'}
                  label={'Způsob platby'}
                  items={paymentMethodEnum}
                  labelFunction={o => get(o, 'label')}
                  valueFunction={o => get(o, 'id')}
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <DateField component={Date} name={'payDate'} label={'Datum zaplacení'} dateOnly={false} />
              </Col>
            </Row>
          </Col>
        </Row>
        <Button label="Uložit a zavřít" primary={true} type={'submit'} style={{ margin: '8px' }} />
        <Button label="Zrušit" style={{ margin: '8px' }} onClick={closeItem} />
      </Grid>
    </form>
  </div>
);

export const EventsFormDelictsBNPPaymentForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormDelictsBNPPaymentForm.tsx